export const environment = {
  production: "{production}",
  syncfusionKey: "Mgo+DSMBMAY9C3t2UlhhQlVMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX9RdkNjXXpXc3JcRmdd",
  apiBaseUrl: "{apiBaseUrl}",
  paymentMaxWaitTime:2,
  paymentGetCCTStatusInterval:10
};
